import { useRef, useCallback } from 'react';

export function useApiCache() {
  const cache = useRef(new Map());
  const timers = useRef(new Map());

  const getCachedData = useCallback((key) => {
    const cached = cache.current.get(key);
    if (cached && Date.now() - cached.timestamp < cached.ttl) {
      return cached.data;
    }
    return null;
  }, []);

  const setCachedData = useCallback((key, data, ttl = 5 * 60 * 1000) => { // 5 минут по умолчанию
    cache.current.set(key, {
      data,
      timestamp: Date.now(),
      ttl
    });

    // Очищаем старый таймер если есть
    if (timers.current.has(key)) {
      clearTimeout(timers.current.get(key));
    }

    // Устанавливаем новый таймер для очистки
    const timer = setTimeout(() => {
      cache.current.delete(key);
      timers.current.delete(key);
    }, ttl);

    timers.current.set(key, timer);
  }, []);

  const clearCache = useCallback(() => {
    cache.current.clear();
    timers.current.forEach(timer => clearTimeout(timer));
    timers.current.clear();
  }, []);

  return { getCachedData, setCachedData, clearCache };
} 